import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { GoogleProvider } from '../../providers/google/google';

@Component({
  selector: 'images-grid',
  templateUrl: 'images-grid.html',
})
export class ImagesGridComponent {
  log = debug('app:ImagesGridComponent');
  googlePlaceId: any = null;
  loading = true;

  @Input() groupPhotos: any = [];
  @Output() init = new EventEmitter<any>();

  constructor(private google: GoogleProvider) {}
  ngOnInit(): void {
    this.init.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/images-grid/images-grid.ts